<template>
	<!-- Start 手机端菜单栏 -->
	<div class="sidebar-group info-group">
		<div class="sidebar-widget">
			<div class="sidebar-widget-container">
				<div class="widget-heading">
					<a href="#" class="close-side-widget">
						<i class="bi bi-x-lg"></i>
					</a>
				</div>
				<div class="sidebar-textwidget">
					<div class="sidebar-info-contents">
						<div class="content-inner">
							<div class="sidebar-logo">
								<a href=""><img src="@/assets/image/footer-logo.png" alt="logo"></a>
							</div>
							<div class="sidebar-widget-menu">
								<ul>
									<li v-for="(item,index) in navList" :key="index" @click="navClick(item)"><a href="javascript:;">{{item.title}}</a></li>
								</ul>
							</div>
							<div class="contact-info">
								<h2>Contact Info</h2>
								<ul class="list-style-one">
									<li><i class="bi bi-geo-alt-fill"></i>厦门市集美区软件园三期B08栋5楼</li>
									<li><i class="bi bi-telephone-fill"></i>0592-6217119</li>
									<li><i class="bi bi-envelope"></i>market@zehuotime.com</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- End it-expart Sidebar Area -->
</template>

<script>
	export default {
		data() {
			return {
				navList: [
					{
						page: 'index',
						title: '首页',
						router: '/'
					},
					{
						page: 'product',
						title: '产品中心',
						router: '/product'
					},
					{
						page: 'solution',
						title: '解决方案',
						router: '/solution'
					},
					{
						page: 'case',
						title: '经典案例',
						router: '/case'
					},
					{
						page: 'news',
						title: '新闻资讯',
						router: '/news'
					},
					{
						page: 'about',
						title: '关于泽火',
						router: '/about'
					}
				]
			}
		},
		methods: {
			navClick(item) {
				if (item.router == this.$route.path) return
				this.$router.push(item.router)
			},
		}
	}
</script>

<style>
</style>